
import { useEffect, useState } from "react";
import apiFetcher from "../utils/apiFetcher";
import { calculatePriceByService } from "../utils/calculatePrice";

const PriceCalculator = ({ active }) => {
  const [type, setType] = useState("");
  const [tons, setTons] = useState(20);
  const [services, setServices] = useState([]);

  const getServices = async () => {
    const res = await apiFetcher.getServices('Kolesin (wieś)');
    setServices(res.service || []);
  };

  useEffect(() => {
    getServices();
  }, []);


  const calculateCubicMeters = (selectedType, tonsAmount) => {
    const density = {  // gęstość w tonach na m³
      "Kruszywo drogowe (certyfikowane)": 1.85,
      "Kruszywa betonowe (przekrusz)": 1.75,
      "Ziemia na podniesienie terenu": 1.50,
      "Piasek zasypowy": 1.65,
      "Ziemia ogrodowa (czarnoziem)": 1.50,
    };

    if (!selectedType || !tonsAmount) return 0;

    const tonsPerM3 = density[selectedType];
    if (!tonsPerM3) return 0;

    return (tonsAmount / tonsPerM3).toFixed(2);
  };




  const totalPrice = calculatePriceByService(type, tons);
  const cubicMeters = calculateCubicMeters(type,tons)
  return (
    <>
      {active && (
        <div className="calculator-section">
          <div id="calendar-container" className="calculator">
            <h3>Kalkulator ceny</h3>

            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="service-select"
            >
              <option value="" disabled>Wybierz usługę</option>
              {services.map((service, i) => (
                <option key={i} value={service}>
                  {service}
                </option>
              ))}
            </select>

            <div>
              <p>Ilość: {tons} ton ~ {cubicMeters}m³</p>
              <input
                type="range"
                min="20"
                max="300"
                step="20"
                value={tons}
                onChange={(e) => setTons(Number(e.target.value))}
              />
            </div>

            <div>
              <p>Cena: <b>{totalPrice.toLocaleString('pl-PL')} zł</b></p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};


export default PriceCalculator;